import * as React from "react";

import {
  PATH,
  VALUABLES_STEPS,
  VALUABLE_ABOUT,
  VALUABLE_PRICE,
} from "./valuablesConstants";
import { ValuablesPriceRequestInfo, ValuablesText } from "./valuablesInterface";

import { ErrorBoundary } from "@sentry/react";
import { ActiveStep } from "Components/ActiveStep";
import { useExistingProductState } from "Components/Features/CheckPrice";
import { ProductTile } from "Components/Features/CheckPrice/Tiles/ProductTile";
import { useTexts } from "Components/TextContext";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { sendPriceCalculationRequestStart } from "Store/priceCalculation/priceCalculationSlice";
import { useProductTexts } from "Store/texts/hooks";
import { useDispatch } from "react-redux";
import { Route } from "react-router-dom";
import { BackendProductInfo } from "../../productConstants";
import { ProductBackendName } from "../../productTypes";
import { ValuablesProductIntro } from "./ProductIntro";
import { ValuablesProductPrice } from "./ProductPrice";

interface Props {
  numberOfProductsInCart: number;
}

export const ValuablesCheckPrice = ({
  numberOfProductsInCart,
}: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const { getText } = useTexts();
  useExistingProductState(INSURANCE_NAME_VALUE.VALUABLES);
  const [texts, lang] = useProductTexts<ValuablesText>(
    ProductBackendName.VALUABLES,
  );

  const updatePriceCalculations = (
    payload: ValuablesPriceRequestInfo,
    stepForwardOnSuccess = true,
  ): void => {
    dispatch(
      sendPriceCalculationRequestStart({
        requestInfo: payload,
        stepForwardOnSuccess,
        productPriceUrl: BackendProductInfo.VALUABLES.priceReqUrl,
        numberOfProductsInCart: numberOfProductsInCart,
      }),
    );
  };

  return (
    <ErrorBoundary
      beforeCapture={(scope) =>
        scope.setTag("location", `CheckPrice - ${ProductBackendName.VALUABLES}`)
      }
    >
      <ProductTile
        title={texts.name[lang]}
        productName={getText("insuranceproduct.valuables.name")}
        productBackendName={ProductBackendName.VALUABLES}
        productPath={PATH}
        productSteps={VALUABLES_STEPS}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        iconName="camera"
      >
        <Route
          exact
          path={`${PATH}/${VALUABLE_ABOUT.id}`}
          render={() => (
            <ActiveStep>
              <ValuablesProductIntro
                sendPriceRequest={updatePriceCalculations}
                texts={texts}
                lang={lang}
              />
            </ActiveStep>
          )}
        />
        <Route
          exact
          path={`${PATH}/${VALUABLE_PRICE.id}`}
          render={() => (
            <ActiveStep>
              <ValuablesProductPrice
                sendPriceRequest={updatePriceCalculations}
                texts={texts}
                lang={lang}
              />
            </ActiveStep>
          )}
        />
      </ProductTile>
    </ErrorBoundary>
  );
};
